import axiosInstance from './axios';

export const stockMovementService = {
  getStockMovements: async (params = {}) => {
    const response = await axiosInstance.get('/stock-movements', { params });
    return response.data;
  },

  getStockMovement: async (id) => {
    const response = await axiosInstance.get(`/stock-movements/${id}`);
    return response.data;
  },

  createStockMovement: async (movementData) => {
    const response = await axiosInstance.post('/stock-movements', movementData);
    return response.data;
  },

  deleteStockMovement: async (id) => {
    const response = await axiosInstance.delete(`/stock-movements/${id}`);
    return response.data;
  },

  getStatistics: async () => {
    const response = await axiosInstance.get('/stock-movements/statistics');
    return response.data;
  },
};
